<div class="project-info" [ngClass]="displayClass">
  <div
    *ngIf="!alwaysDisplay"
    class="clickable back-button icon-circle"
    (click)="hide()"
  >
    <mat-icon class="scale-icon">keyboard_backspace</mat-icon>
  </div>

  <div class="image-container">
    <div
      *ngIf="item.firstAssetStyle != null"
      class="first-image clickable"
      [ngStyle]="item.firstAssetStyle"
      (click)="openLightbox()"
    ></div>

    <div *ngIf="item.firstAssetStyle == null" class="empty-image"></div>
  </div>

  <ng-container *ngIf="item.type !== 'Task'; else taskFirstLine">
    <div
      class="d-flex"
      [ngClass]="item.firstAssetStyle != null ? 'upper-space' : ''"
    >
      <div class="info-padding">
        <div *ngFor="let company of involvedCompanies">
          <span class="strong larger-font">{{ company }}</span>
        </div>
      </div>

      <div
        class="strong larger-font clickable smaller-left-space"
        [routerLink]="['/job', item.project.id, item.id]"
      >
        <span class="secondary-color">#{{ item.project.id }}</span>

        <span
          *ngIf="item.project.oldPlatformId != null"
          class="font-italic"
          [matTooltip]="'Jobnummer oud platform'"
        >
          ({{ item.project.oldPlatformId }})
        </span>
      </div>
    </div>
  </ng-container>

  <ng-template #taskFirstLine>
    <div
      class="d-flex"
      [ngClass]="item.firstAssetStyle != null ? 'upper-space' : ''"
    >
      <div class="info-padding">
        <span class="strong larger-font">
          {{
            item.requestingUser?.firstName
              | personName : item.requestingUser?.lastName
          }}
        </span>
      </div>

      <div
        class="strong larger-font clickable smaller-left-space"
        (click)="openTaskEditModal(item.id)"
      >
        <span class="secondary-color">#{{ item.id }}</span>
      </div>
    </div>
  </ng-template>

  <div
    class="smaller-upper-space type-display-banner"
    [ngClass]="item.typeClass"
  >
    <div>
      {{ item.typeDisplay }}
      <span class="normal">
        ({{ item.currentCreatedAt | date : 'dd/MM/yyyy' }})
      </span>
    </div>
  </div>

  <div
    *ngIf="subProjectItem?.project?.products?.length > 0"
    class="info-padding smaller-upper-space"
  >
    <div *ngFor="let product of subProjectItem.project.products">
      <span class="strong">{{ product.overviewFormat }}</span>
    </div>
  </div>

  <div
    *ngIf="immoTaskItem?.subject?.length > 0"
    class="info-padding smaller-upper-space"
  >
    <span class="strong">{{ immoTaskItem.subject }}</span>
  </div>

  <div class="info-padding">
    {{
      item.address.line1
        | printAddress : item.address.postalCode : item.address.city
    }}
  </div>

  <div
    *ngIf="item.placementFloor != null && item.placementFloor.length > 0"
    class="info-padding"
  >
    Verdieping: {{ item.placementFloor }}
  </div>

  <div
    *ngIf="
      subProjectItem != null &&
      subProjectItem.adjustmentInfo != null &&
      subProjectItem.adjustmentInfo.length > 0
    "
    class="info-padding upper-space font-weight-normal"
  >
    <b *ngIf="subProjectItem.type === 'Adjustment'">Aanpassing: </b>
    {{ subProjectItem.adjustmentInfo }}
  </div>

  <div class="upper-space">
    <mat-form-field
      appearance="outline"
      class="normalize-select font-16 tour-date-picker"
      [ngClass]="item.currentRequestDate != null ? 'date-picker-warning' : ''"
    >
      <input
        matInput
        [min]="today"
        [matDatepicker]="selectedTourDatePicker"
        placeholder="Selecteer een datum"
        [(ngModel)]="selectedTourDate"
      />

      <mat-datepicker-toggle
        matSuffix
        [for]="selectedTourDatePicker"
      ></mat-datepicker-toggle>

      <mat-datepicker #selectedTourDatePicker></mat-datepicker>
    </mat-form-field>
  </div>

  <div *ngIf="placerOptions?.length > 0" class="smaller-upper-space">
    <mat-form-field class="normalize-select font-14" appearance="outline">
      <mat-select
        matInput
        placeholder="Kies een installateur"
        (selectionChange)="updateTempPlacer($event)"
        [(ngModel)]="selectedPlacer"
        name="placer"
        [compareWith]="compareEntities"
      >
        <mat-option *ngFor="let option of placerOptions" [value]="option">
          <span>
            {{ option.user?.firstName | personName : option.user?.lastName }}
          </span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="smaller-upper-space">
    <div
      class="value-display"
      [ngClass]="item.currentRequestDate != null ? 'value-display-warning' : ''"
    >
      <div class="text-display">
        <span>
          {{
            item.currentRequestDate
              | printASAPDateFormat : item.currentRequestASAP : 'dd-MM-yyyy'
          }}
        </span>
      </div>

      <div class="icon-display">
        <mat-icon *ngIf="item.currentRequestDate != null; else emptySpan">
          event
        </mat-icon>

        <ng-template #emptySpan>
          <span class="empty-span">&nbsp;</span>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="small-upper-space actions-container">
    <button
      *ngIf="!submitting; else spinner"
      class="plan-button"
      [ngClass]="
        item.currentRequestDate != null ? 'date-button' : 'asap-button'
      "
      mat-button
      type="button"
      [disabled]="selectedPlacer == null"
      (click)="doPlanItem()"
    >
      Inplannen
    </button>

    <ng-template #spinner>
      <mat-spinner color="primary" diameter="24"></mat-spinner>
    </ng-template>

    <div *ngIf="!submitting" class="lock-checkbox">
      <mat-checkbox [(ngModel)]="locked">LOCK</mat-checkbox>
    </div>
  </div>
</div>
